import { render, staticRenderFns } from "./SupplierManufacturingHome.vue?vue&type=template&id=87a24f04&scoped=true"
import script from "./SupplierManufacturingHome.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a24f04",
  null
  
)

export default component.exports